module.exports = __webpack_public_path__ + "img/poker-c08.f23c92f0.svg";